module.exports = __webpack_public_path__ + "static/media/step_time.13f0c9fe.png";